<template>
  <div class="footer">
    <div class="footer-content">
      <div v-show="isScrolled" class="icon-effect icon-effect-over" @click="backToTop" id="back-top" style="">
        <span class="iconfont-ot-website icon-uparrow">&#xe68f;</span>
        <span class="icon-uparrow">返回顶部</span>
      </div>
      <section class="wrapper clearfix desktop">
        <nav class="footer-nav-list" v-for="(item, index) in completeFooterList" :key="index">
          <h4>{{ item.name }}</h4>
          <ul>
            <li v-for="(subItem, idx) in item.child" :key="idx">
              <a v-if="subItem.isExternalLink" :title="subItem.name" :href="subItem.url"
                :target="subItem.isTarget ? '_blank' : ''" class="span-hover">{{ subItem.name }}</a>
              <router-link v-else :to="subItem.url" :title="subItem.name" class="span-hover">{{ subItem.name
                }}</router-link>
            </li>
          </ul>
        </nav>
      </section>
      <section class="wrapper clearfix mobile">
        <el-collapse>
          <el-collapse-item v-for="(item, index) in completeFooterList" :key="index" :title="item.name" :name="index">
            <li v-for="(subItem, idx) in item.child" :key="idx">
              <a v-if="subItem.isExternalLink" :title="subItem.name" :href="subItem.url"
                :target="subItem.isTarget ? '_blank' : ''" class="span-hover">{{ subItem.name }}</a>
              <router-link v-else :to="subItem.url" :title="subItem.name" class="span-hover">{{ subItem.name
                }}</router-link>
            </li>
          </el-collapse-item>
        </el-collapse>
      </section>
      <section class="footer-item">
        <div class="item-content-social">
          <span class="title">社交媒体账号</span>

          <div class="content">
            <!-- 微信小程序 -->
            <div class="social-icon">
              <i class="iconfont-ot-website">&#xe698;</i>
              <img src="https://assetsprod.onitsukatiger.com/assets/qrcode/OT-WeChat-Mini-Program-qrcode.png"
                class="qrcode" alt="">
            </div>
            <!-- 微信 -->
            <div class="social-icon">
              <i class="iconfont-ot-website">&#xe69a;</i>
              <img src="https://assetsprod.onitsukatiger.com/assets/qrcode/OT-WeChat Official Accounts-qrcode.jpg"
                class="qrcode" alt="">
            </div>
            <!-- 企业微信 -->
            <div class="social-icon">
              <i class="iconfont-ot-website">&#xe696;</i>
              <img src="https://assetsprod.onitsukatiger.com/assets/qrcode/OT-WeCom-qrcode.png" class="qrcode" alt="">
            </div>
            <!-- 微博 -->
            <!-- <a href="https://assetsprod.onitsukatiger.com/assets/qrcode/OT-redbook-qrcode.png" target="_blank" class="social-icon">
              <i class="iconfont-ot-website">&#xe699;</i>
            </a> -->
            <!-- <div class="social-icon">
              <i class="iconfont-ot-website">&#xe699;</i>
              <img src="https://assetsprod.onitsukatiger.com/assets/qrcode/OT-weibo-qrcode.jpg" class="qrcode" alt="">
            </div> -->
            <!-- 微博 -->
            <a href="https://weibo.com/onitsukatigerchina" target="_blank" class="social-icon">
              <i class="iconfont-ot-website">&#xe699;</i>
            </a>
            <!-- 小红书 -->
            <div class="social-icon">
              <i class="iconfont-ot-website">&#xe695;</i>
              <img src="https://assetsprod.onitsukatiger.com/assets/qrcode/OT-redbook-qrcode.png" class="qrcode" alt="">
            </div>
            <!-- 视频号 -->
            <!-- <a href="https://weibo.com/onitsukatigerchina" target="_blank" class="social-icon">
              <i class="iconfont-ot-website">&#xe697;</i>
            </a> -->
          </div>
        </div>
      </section>
      <section class="footer-item footer-item-bottom">
        <div class="item-content-bottom item-logo">
          <span class="bottom-txt">ESTABLISHED IN KOBE, JAPAN, 1949</span>
          <div class="logo-block">
            <img class="logo-icon" src="../assets/imgs/footer/white-logo.png" />
          </div>
          <span class="bottom-txt">BY MR KIHACHIRO ONITSUKA</span>
        </div>
        <div class="item-content-bottom">
          <div class="b-item mobile">
            <span class="txt">ONITSUKA TIGER IS A REGISTERED TRADEMARK OF ASICS CORPORATION</span>
          </div>
          <div class="b-item w-100 mobile">
            <span class="txt">亚瑟士(中国)商贸有限公司</span>
          </div>
          <div class="b-item">
            <a
              href="http://wap.scjgj.sh.gov.cn/businessCheck/verifKey.do?showType=extShow&serial=9031000020161017100651000001301590-SAIC_SHOW_310000-20171019180302870615&signData=MEYCIQCVCRW2ZYU1RjjoypqLit9WNAyxJevmR4xuV45EPxaTRgIhAKBKMzjENS4D3rbQsdjDFCj3tuUnSmBNh5/YvlfQSqfO">
              <img class="shgs-icon" src="../assets/imgs/footer/shgs1.png" />
              <!-- <img class="shgs-icon" src="https://www.asics.com.cn/system/images/shgs.jpg" /> -->
              <span class="txt">电子营业执照</span>
            </a>
          </div>
          <div class="b-item">
            <a href="https://beian.mps.gov.cn/#/query/webSearch">
              <img class="shgs-icon" src="../assets/imgs/footer/filing-1.png" />
              <span class="txt">沪公网安备：31010502007223号</span>
            </a>
          </div>
          <div class="b-item">
            <img class="shgs-icon" src="../assets/imgs/footer/filing-2.png" />
            <span class="txt">沪ICP备10203942号-2</span>
          </div>
          <div class="b-item">
            <span class="txt">中国大陆</span>
          </div>
        </div>
        <div class="item-content-bottom">
          <div class="b-item desktop">
            <span class="txt">ONITSUKA TIGER IS A REGISTERED TRADEMARK OF ASICS CORPORATION</span>
          </div>
          <div class="b-item desktop">
            <span class="txt">亚瑟士(中国)商贸有限公司</span>
          </div>
          <div class="b-item">
            <span class="txt">©{{ currentYear }} Onitsuka Tiger. All Rights Reserved</span>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import wxQRCode from '@/assets/imgs/footer/wx-logo.jpg';

export default {
  data() {
    return {
      isScrolled: false,
      lastScrollTop: 0,
      ticking: false, // 用于节流
      footerList: [
        {
          name: "网站支持",
          showSub: false,
          child: [
            { name: "尺码对照表", url: "/size-guide" },
            { name: "店铺查找", url: "/store-finder" }
          ]
        },
        {
          name: "客户服务",
          showSub: false,
          child: [
            { name: "关于订单", url: "/about-order" },
            { name: "联系我们", url: "/privacy-policy?active=2" }
          ]
        },
        {
          name: "关于鬼塚虎",
          showSub: false,
          child: [
            { name: "隐私政策", url: "/cms/privacy-policy" },
            // { name: "隐私政策", url: "https://legal.asics.com/cn-cn/legal/privacy-policy",isExternalLink:true },
            { name: "关于Onitsuka Tiger", url: "/privacy-policy?active=4" },
            { name: "Cookie政策", url: "https://legal.asics.com/cn-cn/legal/cookie-policy", isExternalLink: true },
            // { name: "负责使用个人资料的ASICS公司概述", url: "https://legal.asics.com/cn-cn/legal/overview-of-asics-companies",isExternalLink:true },
            { name: "销售条款", url: "/cms/terms-and-conditions" },
            // { name: "地区差异", url: "/privacy-policy?active=6" }
          ]
        }
      ],
      showWxQRCode: false,
      wxQRCode
    };
  },
  methods: {
    backToTop() {
      // 平滑滚动到顶部
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },

    handleScroll() {
      // 使用 requestAnimationFrame 节流
      if (!this.ticking) {
        requestAnimationFrame(() => {
          this.updateScrollState();
          this.ticking = false;
        });
        this.ticking = true;
      }
    },

    updateScrollState() {
      const currentScroll = window.scrollY;
      const scrollThreshold = 100;
      const scrollBuffer = 30;

      // 添加缓冲区避免频繁切换
      if (currentScroll > this.lastScrollTop && currentScroll > scrollThreshold + scrollBuffer) {
        // 向下滚动且超过阈值+缓冲区，隐藏
        this.isScrolled = true;
      } else if (currentScroll < this.lastScrollTop && currentScroll < scrollThreshold - scrollBuffer) {
        // 向上滚动且低于阈值-缓冲区，显示
        this.isScrolled = false;
      }
      // 在缓冲区域内保持当前状态不变

      this.lastScrollTop = currentScroll;
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);

  },
  computed: {
    // 添加会员规则作为一个单独的计算属性
    membershipRuleItem() {
      const config = this.$store.state.commonConfig;
      const url = (config && config['MemberShip-Rules']) ||
        'https://statics.maiscrm.com/663c66976dc8b037dc6d0783/modules/retail/o_1j2lp85801ac61nup131sgtqp40/%E3%80%90FINAL%E3%80%91Onitsuka%20Tiger%20%E4%BC%9A%E5%91%98%E8%A7%84%E5%88%99V2025.8.15-%20%E5%85%A8%E6%B8%A0%E9%81%93.pdf';

      return {
        name: "会员规则",
        url: url,
        isExternalLink: true,
        isTarget: true
      };
    },

    // 重构 footerList 以包含会员规则
    completeFooterList() {
      const list = [...this.footerList];
      if (list[2] && list[2].child) {
        // 创建新的子项数组并添加会员规则
        list[2] = {
          ...list[2],
          child: [...list[2].child, this.membershipRuleItem]
        };
      }
      return list;
    },
    isMobile() {
      return window.innerWidth <= 1024;
    },
    currentYear() {
      return new Date().getFullYear();
    },
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>

<style lang='scss' scoped>
@media only screen and (min-width: 1024px) {
  .desktop {
    display: block;
  }

  .mobile {
    display: none !important;
  }

  .footer-content {
    margin-top: 320px;
    padding: 35px 115px;
    background: #212322;
    font-size: 16px;
    color: #fff;
    border-top: 1px solid rgb(191, 191, 191);
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    gap: 48px;
    align-items: center;
    max-width: 1200px;
    margin: auto;


    #back-top {
      height: 50px;
      width: 50px;
      position: fixed;
      bottom: 20px;
      cursor: pointer;
      transition: all .3s ease-in-out;
      opacity: .95;
      text-align: center;
      line-height: normal;
      border-radius: 50px;
      background-color: #f5f5f5;
      z-index: 99;
      -webkit-backface-visibility: hidden;
      transform: translateZ(0);
      -webkit-transform: translateZ(0);
      right: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      .iconfont-ot-website {
        font-size: 16px !important;
        transform: rotate(-90deg)
      }

      .icon-uparrow {
        font-size: 9px;
      }
    }

    #back-top span.icon-uparrow {
      transition: all .3s ease-in-out;
      color: #000;
      text-transform: uppercase;
      display: inline-block;
      line-height: 18px;
      font-weight: 300
    }

    #back-top span.icon-uparrow:before {
      display: block;
      font-weight: 300;
      color: #000;
      line-height: 12px;
      margin-top: 10px;
      position: relative;
      top: 0;
      font-family: 'onitsukatiger-icon';
      text-align: center;
      transition: all .3s ease-in-out
    }

    #back-top:hover {
      opacity: 1;
      color: #fff;
      background-color: #000
    }

    #back-top:hover span.icon-uparrow {
      color: #fff
    }

    #back-top:hover span.icon-uparrow:before {
      color: #fff
    }

    #back-top.icon-effect {
      transition: all .3s ease-in-out
    }

    #back-top.icon-effect:after {
      border-radius: 50%;
      box-sizing: content-box;
      content: "";
      height: 100%;
      pointer-events: none;
      position: absolute;
      width: 100%
    }

    #back-top.icon-effect-over {
      transition: all .3s ease-in-out
    }

    #back-top.icon-effect-over:after {
      opacity: 0;
      padding: 2px;
      box-shadow: 0 0 0 2px #000;
      top: -2px;
      transform: scale(.3);
      transition: transform .4s ease 0s, opacity .4s ease 0s;
      z-index: -1;
      left: -2px
    }

    #back-top:hover {
      transition: all .3s ease-in-out
    }

    #back-top:hover.icon-effect-over:after {
      opacity: 1;
      z-index: 1;
      transform: scale(1);
    }


    .footer-item {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      .item-content-social {
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #fff;

        .title {
          font-size: 12px;
          color: #fff;
          margin-bottom: 20px;
        }

        .content {
          display: flex;
          gap: 28px;
          flex-direction: row;
          align-items: center;
          font-size: 24px;
        }

        .social-icon {
          width: 24px;
          height: 24px;
          border-radius: 50%;
          padding: 4px;
          color: #fff;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          box-sizing: unset;
          overflow: visible;

          &::before {
            content: "";
            position: absolute;
            background: #fff;
            border-radius: 50%;
            transform: scale(0);
            opacity: 0;
            visibility: hidden;
            -webkit-transform: scale(0);
            width: 32px;
            height: 32px;
            left: 0;
            z-index: -1;
            top: 0;
            -webkit-transition: all .35s ease-in-out;
            -moz-transition: all .35s ease-in-out;
            -o-transition: all .35s ease-in-out;
            -ms-transition: all .35s ease-in-out;
            transition: all .35s ease-in-out
          }

          .qrcode {
            display: none;
            /* 默认隐藏二维码 */
            position: absolute;
            bottom: -88px;
            /* 显示在图标的上方 */
            left: 50%;
            transform: translateX(-50%);
            width: 80px;
            height: 80px;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
            z-index: 10;
            max-width: fit-content;
          }

          &:hover {
            color: #212322;
            &::before {
              transform: scale(1);
              opacity: 1;
              visibility: visible;
              -webkit-transform: scale(1);
            }

            .qrcode {
              display: block;
              /* 悬停时显示二维码 */
            }
          }
        }

        .iconfont-ot-website {
          // color: #fff;
          font-size: 24px;
          cursor: pointer;
        }
      }

      .item-content-bottom {
        display: flex;
        color: #fff;
        align-items: center;
        justify-content: center;
        gap: 15px;

        &.item-logo {
          margin-bottom: -5px;
        }

        .b-item {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          flex-direction: row;

          a {
            display: flex;
            color: #fff;
            align-content: center;
            justify-content: center;

            .txt {
              line-height: 18px;
              padding-left: 8px;
              font-size: 10px;
            }
          }

        }

        .bottom-txt {
          color: #fff;

          font-family: Matter;
          font-size: 10px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          text-transform: capitalize;
          width: 162px;
          text-align: left;
        }

        .shgs-icon {
          // margin-left: 1rem;
          width: 16px;
          height: auto;
          display: block;
        }
      }

      &.footer-item-bottom {
        gap: 10px;
        font-size: 10px;

        .logo-icon {
          width: 28px;
          height: 30px;

        }
      }
    }


  }
}

@media only screen and (max-width: 1024px) {
  .desktop {
    display: none !important;
  }

  .mobile {
    display: block;
  }

  .footer-content {
    // margin-top: 32px;
    padding: 15px;
    background: #212322;
    font-size: 16px;
    color: #fff;
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    gap: 32px;
    align-items: center;
    width: 100%;
    box-sizing: border-box;


    #back-top {
      height: 40px;
      width: 40px;
      position: fixed;
      bottom: 20px;
      cursor: pointer;
      transition: all .3s ease-in-out;
      opacity: .95;
      text-align: center;
      line-height: normal;
      border-radius: 50px;
      background-color: #f5f5f5;
      z-index: 99;
      -webkit-backface-visibility: hidden;
      transform: translateZ(0);
      -webkit-transform: translateZ(0);
      right: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      .iconfont-ot-website {
        font-size: 16px !important;
        transform: rotate(-90deg)
      }

      .icon-uparrow {
        font-size: 7px;
      }
    }

    #back-top span.icon-uparrow {
      transition: all .3s ease-in-out;
      color: #000;
      text-transform: uppercase;
      display: inline-block;
      line-height: 14px;
      font-weight: 300
    }

    #back-top span.icon-uparrow:before {
      display: block;
      font-weight: 300;
      color: #000;
      line-height: 12px;
      margin-top: 10px;
      position: relative;
      top: 0;
      font-family: 'onitsukatiger-icon';
      text-align: center;
      transition: all .3s ease-in-out
    }

    #back-top:hover {
      opacity: 1;
      color: #fff;
      background-color: #000
    }

    #back-top:hover span.icon-uparrow {
      color: #fff
    }

    #back-top:hover span.icon-uparrow:before {
      color: #fff
    }

    #back-top.icon-effect {
      transition: all .3s ease-in-out
    }

    #back-top.icon-effect:after {
      border-radius: 50%;
      box-sizing: content-box;
      content: "";
      height: 100%;
      pointer-events: none;
      position: absolute;
      width: 100%
    }

    #back-top.icon-effect-over {
      transition: all .3s ease-in-out
    }

    #back-top.icon-effect-over:after {
      opacity: 0;
      padding: 2px;
      box-shadow: 0 0 0 2px #000;
      top: -2px;
      transform: scale(.3);
      transition: transform .4s ease 0s, opacity .4s ease 0s;
      z-index: -1;
      left: -2px
    }

    #back-top:hover {
      transition: all .3s ease-in-out
    }

    #back-top:hover.icon-effect-over:after {
      opacity: 1;
      z-index: 1;
      transform: scale(1);
    }


    &::v-deep .el-collapse {
      border: none;
      width: 100%;


      .el-collapse-item__arrow {
        transform: rotate(90deg);
        font-size: 18px;

        &.is-active {
          transform: rotate(-90deg);
        }
      }
    }

    &::v-deep .el-collapse-item__header {
      background: #212322;
      color: #fff;
      border-bottom: none;
      border: none;
      height: 56px;
      line-height: 56px;
      font-size: 14px;
      font-weight: 500;
    }

    &::v-deep .el-collapse-item__wrap {
      background-color: #212322;
      border-bottom: none;

      .el-collapse-item__content {
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding-left: 30px;
        padding-bottom: 0;

        li {
          text-align: left;
          padding: 8px 0;
        }

        .span-hover {
          color: #fff;
          font-size: 12px;
        }
      }
    }

    .footer-item {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      .item-content-social {
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #fff;

        .title {
          font-size: 12px;
          color: #fff;
          margin-bottom: 20px;
        }

        .content {
          display: flex;
          row-gap: 20px;
          column-gap: 40px;
          flex-direction: row;
          align-items: center;
          font-size: 24px;
          justify-content: center;
          padding: 0 60px;
          flex-wrap: wrap;
        }

        .social-icon {
          -webkit-transition: all .35s ease-in-out;
          -moz-transition: all .35s ease-in-out;
          -o-transition: all .35s ease-in-out;
          -ms-transition: all .35s ease-in-out;
          transition: all .35s ease-in-out;
          width: 24px;
          height: 24px;
          border-radius: 50%;
          padding: 4px;
          color: #fff;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          box-sizing: unset;
          overflow: visible;

          &::before {
            content: "";
            position: absolute;
            background: #fff;
            border-radius: 50%;
            transform: scale(0);
            opacity: 0;
            visibility: hidden;
            -webkit-transform: scale(0);
            width: 32px;
            height: 32px;
            z-index: -1;
            left: 0;
            top: 0;
            -webkit-transition: all .35s ease-in-out;
            -moz-transition: all .35s ease-in-out;
            -o-transition: all .35s ease-in-out;
            -ms-transition: all .35s ease-in-out;
            transition: all .35s ease-in-out
          }

          i {
            position: relative;
            z-index: 1;
          }

          .qrcode {
            display: none;
            position: absolute;
            bottom: -88px;
            left: 50%;
            transform: translateX(-50%);
            width: 80px;
            height: 80px;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
            z-index: 10;
            max-width: fit-content;
          }

          &:hover {
            color: #212322;

            &::before {
              transform: scale(1);
              opacity: 1;
              visibility: visible;
              -webkit-transform: scale(1);
            }

            .qrcode {
              display: block;
            }
          }

          &:focus {
            background: transparent;
            color: #fff;

            .qrcode {
              display: none;
            }
          }
        }

        .iconfont-ot-website {
          font-size: 24px;
        }
      }

      .item-content-bottom {
        display: flex;
        color: #fff;
        align-items: center;
        justify-content: center;
        gap: 6px;
        flex-wrap: wrap;
        padding: 0 18px;


        .b-item {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          flex-direction: row;
          font-size: 8px;

          a {
            display: flex;
            color: #fff;
            align-content: center;
            justify-content: center;

            .txt {
              line-height: 18px;
              padding-left: 8px;
              font-size: 8px;
            }
          }
        }

        .w-100 {
          width: 100%;
        }

        .bottom-txt {
          color: #fff;

          font-family: MatterSQ;
          font-size: 8px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          text-transform: capitalize;
          width: 130px;
          text-align: left;
        }

        .shgs-icon {
          // margin-left: 1rem;
          width: 16px;
          height: auto;
          display: block;
        }
      }

      &.footer-item-bottom {
        gap: 10px;
        font-size: 8px;

        .logo-icon {
          width: 16px;
          height: 17px;

        }
      }
    }


  }
}

.footer {
  background: #212322;



  .footer-nav-list {
    color: #fff;
    display: flex;
    gap: 10px;
    flex-direction: column;

    ul {
      display: flex;
      gap: 10px;
      flex-direction: column;
    }

    h4 {
      font-size: 16px;
      font-weight: 600;
      color: #fff;
      // cursor: pointer;
    }
  }


  section {
    box-sizing: border-box;
    // max-width: 1200px;
    margin: 0 auto;
    width: 100%;
  }

  .wrapper {
    display: flex;
    justify-content: space-between;

    .fr {
      float: right;
    }

    .footer-nav-list {
      min-height: 10px;
      // padding: 0 15px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      text-align: left;

      a {
        color: #fff;
        line-height: 18px;
        margin-bottom: 4px;
        font-size: 12px;
        cursor: pointer;

        position: relative;
        text-decoration: none; // 去除默认下划线

        &::after {
          content: '';
          position: absolute;
          bottom: -4px; // 距离文字底部的距离
          left: 0;
          width: 0;
          height: 1px;
          background-color: #fff;
          transition: width 0.5s ease; // 添加过渡动画
        }

        &:hover {
          color: #fff;

          &::after {
            width: 100%; // 悬停时展开到全宽
          }
        }
      }



      .span-hover:hover {
        color: #fff;
        // border-bottom: 1px solid #fff;
        cursor: pointer;
      }
    }

    h4 {
      // color: #666;
      // font-size: 16px;
      // text-transform: uppercase;
      // line-height: 1.8;
      // font-weight: 600;
      // border-bottom: 1px solid #666;
      // margin-bottom: 1.2rem;
      // letter-spacing: 1px;

      &.no-underline {
        border-bottom: 0;
      }

      &.thin {
        color: #999;
        font-weight: 400;
        text-transform: none;
      }

      &.thin+small {
        font-size: 1.6rem;
        line-height: 1.5;
      }

      &>em {
        font-style: normal;
      }
    }

    .contact-wrapper {
      min-height: 10px;
      padding: 0 15px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      text-align: left;

      .social-box {
        display: flex;
        flex-direction: column;

        .txt {
          margin-bottom: 10px;

          a {
            color: #000000;
            line-height: 12px;
            margin-bottom: 4px;
            font-size: 12px;

            &:hover {
              color: #000000;
              border-bottom: 1px solid white;
              cursor: pointer;
            }
          }
        }

        .wx {
          width: 82px;
          height: auto;
          margin-top: 10px;
        }

        .icon-btn {
          .iconfont {
            display: none;
          }
        }

        .wx-icon {
          position: relative;
        }

        .icon-link {
          .webo {
            color: #fff;
          }
        }
      }

      .wx-qr_code {
        text-align: center;

        .wx-image {
          margin-top: 20px;
          display: none;

          &.show {
            display: inline-block;
          }
        }
      }
    }
  }

  .footer-bottom {
    margin: 0;
    max-width: 100%;
    font-size: 1.1rem;

    .bottom-max {
      display: flex;
      align-items: center;
      justify-content: space-around;
      height: 5rem;
      width: 100%;

      // background-image: url("../assets/imgs/footer/footer_banner.jpg");
      small {
        line-height: 2rem;
      }

      .max-center {
        display: flex;
        align-items: center;
        height: 100%;

        .logo-block {
          height: 100%;
          width: 6.4rem;
          margin: 0 2rem;
          position: relative;

          .logo-icon {
            position: absolute;
            left: 50%;
            top: 50%;
            margin-left: -3.2rem;
            margin-top: -2.5rem;
          }
        }
      }
    }

    .color-line {
      width: 100%;
      height: 10px;
      background: #CD0037;
      margin-top: 4rem;
    }

    .footer-copyright {
      display: flex;
      justify-content: center;
      margin: 3rem auto 1rem;

      .cr-block {
        display: flex;
        flex-direction: column;
        align-items: center;

        .shgs-block {
          display: flex;
          align-items: center;
          margin-top: 0.5rem;

          .shgs-icon {
            margin-left: 1rem;
            height: 2.3rem;
            width: 2rem;
          }
        }
      }
    }
  }

  .owner-name {
    font-size: 12px;
    color: #212322;
  }
}

// @media only screen and (max-width: 1024px) {
//   .footer {
//     // padding-top: 32px;
//     // padding-bottom: 2rem;
//     background: #212322;
//     font-size: 16px;
//     color: #999;

//     section {
//       box-sizing: border-box;
//       width: auto;
//       margin: 0 auto;
//     }

//     .wrapper {
//       width: 100%;
//       // min-height: 212px;
//       flex-direction: column;
//       justify-content: flex-start;
//       box-sizing: border-box;

//       .single {
//         width: 16.66666667%;
//       }

//       .fl {
//         float: none;
//       }

//       .fr {
//         float: right;
//       }

//       .footer-nav-list {
//         width: auto;
//         border-top: 1px solid #222;
//         padding: 0;

//         li {
//           padding: 5px 0;
//         }

//         a {
//           // display: block;
//           color: #999;
//           line-height: 18px;
//           margin-bottom: 4px;
//           font-size: 12px;
//         }

//         .span-hover:hover {
//           color: white;
//           border-bottom: 1px solid white;
//           cursor: pointer;
//         }

//         ul {
//           display: none;
//         }
//       }

//       h4 {
//         padding: 0 1.5rem;
//         border-bottom: 0;
//         position: relative;
//         margin-bottom: 0;
//         height: 52px;
//         line-height: 52px;

//         &.open {
//           background: #1c1c1c;
//         }

//         &.open+ul {
//           display: block;
//           background: #1c1c1c;
//           padding: 0 1.5rem 1rem;
//         }

//         &.open::before {
//           content: "-";
//           position: absolute;
//           top: 50%;
//           font-size: 24px;
//           font-weight: 200;
//           right: 1.5rem;
//           width: 1.6rem;
//           transform: translateY(-50%);
//           margin: auto;
//           color: #fff;
//           text-align: center;
//         }

//         // &::before {
//         //   content: "+";
//         //   position: absolute;
//         //   top: 50%;
//         //   font-size: 24px;
//         //   font-weight: 200;
//         //   right: 1.5rem;
//         //   width: 1.6rem;
//         //   transform: translateY(-50%);
//         //   margin: auto;
//         //   color: #fff;
//         //   text-align: center;
//         // }

//         &::before:last-child {
//           content: "";
//         }

//         &.thin {
//           color: #999;
//           font-weight: 400;
//           text-transform: none;
//         }

//         &.thin+small {
//           font-size: 1.6rem;
//           line-height: 1.5;
//         }

//         &>em {
//           font-style: normal;
//         }
//       }

//       .no-underline {
//         border-bottom: 0;
//         // display: none;
//       }

//       .contact-wrapper {
//         width: 100%;
//         padding: 10px 15px;
//         display: flex;
//         flex-direction: column;
//         justify-content: center;
//         box-sizing: border-box;

//         h4 {
//           // display: none;
//         }

//         .social-box {
//           display: flex;
//           flex-direction: row;
//           justify-content: center;

//           .icon-btn {
//             .iconfont {
//               display: block;
//             }
//           }

//           .txt {
//             // display: none;
//           }

//           .weibo-icon {
//             margin-left: 14px;
//           }
//         }
//       }
//     }

//     .footer-bottom {
//       margin: 0;
//       max-width: 100%;
//       font-size: 1.1rem;

//       .bottom-max {
//         display: flex;
//         display: -webkit-flex;
//         align-items: center;
//         flex-direction: column;
//         -webkit-align-items: center;
//         justify-content: space-around;
//         -webkit-justify-content: space-around;
//         height: auto;
//         padding: 20px 0;
//         background-image: url("../assets/imgs/footer/footer_banner.jpg");
//         width: 100%;

//         small {
//           line-height: 2rem;
//         }

//         .max-center {
//           display: flex;
//           display: -webkit-flex;
//           align-items: center;
//           flex-direction: column;
//           -webkit-align-items: center;
//           height: 100%;

//           .logo-block {
//             height: 100%;
//             width: 7.2rem;
//             margin: 0 2rem;
//             position: relative;

//             .logo-icon {
//               display: none;
//             }
//           }
//         }
//       }

//       .footer-copyright {
//         display: flex;
//         display: -webkit-flex;
//         justify-content: center;
//         -webkit-justify-content: center;
//         margin: 6rem auto 1rem;

//         .cr-block {
//           display: flex;
//           display: -webkit-flex;
//           flex-direction: column;
//           -webkit-flex-direction: column;
//           align-items: center;
//           -webkit-falign-items: center;

//           .shgs-block {
//             display: flex;
//             display: -webkit-flex;
//             margin-top: 0.5rem;
//             align-items: center;
//             -webkit-align-items: center;

//             .shgs-icon {
//               margin-left: 1rem;
//               height: 2.3rem;
//               width: 2rem;
//             }
//           }
//         }
//       }
//     }

//     .owner-name {
//       color: rgb(153, 153, 153);
//     }
//   }
// }</style>
